<template>
  <div class="main-box">
    <div v-if="resourceId != null && resourceId != '' && resourceId != undefined" class="upload-view-div" @click="clickDiv" style="text-align: center;">
      <img :src="imgUrl" style="height: 100%;">
    </div>
    <div v-else class="upload-view-div" @click="clickDiv" style="text-align: center;">
      <img src="../../assets/img/upload.png" style="height: 20px;margin: 20px auto;">
    </div>
    <xr-upload ref="xrUploadDialog" accept=".png,.jpg" :limit="limitNum" :businessType="businessType" :targetId="targetId" :onUploadedClose="true" @confirmMethod="uploadSuccess(arguments)"></xr-upload>
  </div>
</template>

<script>

    import { getToken } from '@/utils/auth'

    export default {
        name: "index",
        props: ['resourceId',"businessType","data1","targetId"],
        data(){
          return {
            uploadDialogVisible:  false,        //上传文件的弹出框
            showClean: false,
            maxAbleAmount: 0,
            dialogImageUrl: '',
            imgUrl: '',
            dialogVisible: false,
            limitNum: 1,
            paramsObj: new Object(),
            uploadUrl: process.env.BASE_URL + "/web/uploadResource",                       //文件上传地址
            importAccept: '.png,.jpg,.JPEG',
            getUrlAddr: '',                      //获取地址前缀
            resourceUrl: '',                     //资源文件的地址

          }
        },
        watch : {
          //资源ID修改了，同步的资源地址赋值上。
          resourceId:function(val) {
            this.imgUrl = process.env.FILE_URL + "/web/getResource/" + val
          }
        },
        created(){
          this.imgUrl = process.env.FILE_URL + "/web/getResource/" + this.resourceId
          this.paramsObj['accessToken'] = getToken();
        },
        methods: {

          //开启上传文件
          openUpload(){
            this.uploadDialogVisible = true;
          },

          //点击框框
          clickDiv(){
            this.$refs.xrUploadDialog.init() //初始化页面
          },
          //导入成功后的操作
          uploadSuccess(msg){
            let resultResourceId = msg[0][0].id;

            console.log('+++++++++uploadSuccess++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');
            console.log(msg);
            console.log(msg[0]);

            this.imgUrl = process.env.FILE_URL + "/web/getResource/" + resultResourceId
            this.$emit('changeMethod',resultResourceId); //通知父组件改变。
          },

          //预览
          handlePictureCardPreview(file) {
            this.dialogImageUrl = this.getUrlAddr + file.resourceId;
            this.dialogVisible = true;
          },
        }
    }
</script>

<style>
  .uploadPic .el-upload-list--picture-card .el-upload-list__item{width: 100px !important;height: 100px !important;}
  .uploadPic .el-upload--picture-card{width: 100px !important;height: 100px !important;line-height: 100px !important;}

  .upload-view-div{width: 100%;height: 60px;border: 1px solid #ccc;cursor: pointer;border-radius: 4px;}
  .upload-view-div .upload-div{display: block; height: 30%; margin: 20px auto;}
  .upload-view-div .upload-div .el-upload{width: 100%;height: 100%;}
  .upload-view-div .upload-div .el-upload img{height: 100%;margin: 0px auto;}

  .el-upload-list__item.is-success{display: none;}



  .upload-demo{text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/XrUploadSinglePicture/index.vue